import { Flex, Select, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'translations/hooks';

import { DateRangeValue } from 'technical/types';
import { NumberRangeValue } from 'ui/form/number-range-input';
import { useRangeSize } from 'ui/form/preselect-ring-range-input/use-range-size';

import styles from './index.module.scss';

export enum PreselectRingRangeTypeEnum {
  All = 'all',
  LastTen = 'lastTen',
  LastFifty = 'lastFifty',
  LastOneHundred = 'lastOneHundred',
  LastTwoHundred = 'lastTwoHundred',
}

export interface PreselectRingRangeInputProps {
  defaultType: PreselectRingRangeTypeEnum;
  value?: DateRangeValue;
  onChange?: (value: NumberRangeValue) => void;
  lastRing?: number | null;
  error?: boolean;
}

export const PreselectRingRangeInput = ({
  defaultType,
  onChange,
  lastRing,
  error,
}: PreselectRingRangeInputProps) => {
  const { t } = useTranslation();

  const [currentType, setCurrentType] =
    useState<PreselectRingRangeTypeEnum>(defaultType);

  const handleRingChange = (ringRange: NumberRangeValue) => {
    if (onChange) {
      onChange(ringRange);
    }
  };

  const { handleSelectChange, options } = useRangeSize(
    setCurrentType,
    handleRingChange,
    lastRing,
  );

  return (
    <Flex>
      <Select
        value={currentType}
        onChange={(value) => handleSelectChange(value)}
        options={options}
        popupMatchSelectWidth={false}
      />
      {error ? (
        <Typography.Text
          italic
          type="secondary"
          className={styles.currentRingNumber}
        >
          {t('dataAnalysis.errors.currentRingNumberError')}
        </Typography.Text>
      ) : null}
    </Flex>
  );
};
